import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import AddButton from "../../buttons/button";
import CloseIcon from "../../../assets/icons/close-icon";
import LoadingOverlay from "../../helper-components/overlay-loading";
import { Formik } from "formik";
import { Form } from "formik";
import { useDispatch } from "react-redux";
import {
  stockDetailsBatchUpdateAction,
  stockDetailsBatchViewAction,
} from "../../../redux/actions/stock-details-audit-action";
import SelectField from "../../forms/select-field";
import InputField from "../../forms/input-field";
import TabsComponent from "../../helper-components/tabs-component";
import successToast from "../../helper-components/success-toast";
import moment from "moment";

export default function StockDetailsBatchPanel({
  open,
  setOpen,
  currentBatch = {},
  data,
  productDetails,
  setCurrentBatch,
}) {
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [batchDetails, setBatchDetails] = useState({});
  const [currentTab, setCurrentTab] = useState("Basic Pricing");
  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      dispatch(
        stockDetailsBatchViewAction(
          {
            item_batch_number: currentBatch?.item_batch_number,
            item_id: currentBatch?.item_id,
          },
          onSuccess,
          onError
        )
      );
    }
  }, [open, reload, currentBatch]);

  const onSuccess = (data) => {
    setLoading(false);
    setBatchDetails(data?.data || {});
  };
  const onError = (data) => {
    setLoading(false);
  };

  const initialValues = {
    item_batch_number: batchDetails?.item_batch_number,
    item_name: currentBatch?.item_name,
    item_id: currentBatch?.item_id,
    unit_mrp: batchDetails?.unit_mrp,
    item_mrp_price: batchDetails?.item_mrp_price,
    item_hsn: batchDetails?.item_hsn,
    units_per_pack: batchDetails?.units_per_pack,
    item_exp_date: batchDetails?.item_exp_date
      ? moment(batchDetails?.item_exp_date).format("YYYY-MM-DD")
      : "",
    item_hsn: batchDetails?.item_hsn,
    item_quantity: batchDetails?.item_quantity,
    final_cost_price_excl_gst: batchDetails?.final_cost_price_excl_gst,
    final_cost_price_incl_gst: batchDetails?.final_cost_price_incl_gst,
    margin_percentage: batchDetails?.margin_percentage,
    profit_margin: batchDetails?.profit_margin,
    gst: batchDetails?.gst,
    discount_percentage: batchDetails?.discount_percentage,
    item_unit_price: batchDetails?.item_mrp_price,
    advanced_pricing: batchDetails?.advanced_pricing || [],
  };

  const onSubmit = (values) => {
    console.log(values, "dfdsfdsfssfs");
    dispatch(
      stockDetailsBatchUpdateAction(
        {
          type:
            currentTab === "Basic Pricing"
              ? "basic_pricing"
              : "advance_pricing",
          item_id: values?.item_id,
          item_batch_number: values?.item_batch_number,
          item_mrp_price: values?.item_unit_price,
        },
        onUpdateSuccess,
        onUpdateError
      )
    );
  };

  const onUpdateSuccess = (data) => {
    setReload(!reload);
    successToast(data?.message);
  };
  const onUpdateError = (data) => {};

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[60%] bg-[var(--slide-panel-special-bg)] overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                {/* Header */}
                <Formik
                  enableReinitialize={true}
                  initialValues={initialValues}
                  onSubmit={onSubmit}
                >
                  {({ values, setFieldValue }) => {
                    return (
                      <Form className="h-full bg-[var(--slide-panel-head-bg)] w-full">
                        <div
                          className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                          style={{ borderColor: "var(--slide-panel-border)" }}
                        >
                          <div
                            style={{
                              maxHeight: "32px",
                              color: "var(--slide-panel-h-fg)",
                              fontSize: "var(--slide-panel-h-fs)",
                              fontWeight: "var(--slide-panel-h-fw)",
                            }}
                            className="min-w-[75%] "
                          >
                            Update Stock Details
                          </div>
                          <AddButton
                            onclkFn={() => {
                              setOpen(false);
                              // setProductDetails({ item_id: "" });
                            }}
                            icon={
                              <CloseIcon
                                width="12px"
                                height="12px"
                                fill="var(--close-button-fg)"
                              />
                            }
                            text={
                              <span>
                                Close <span className="opacity-50">(X)</span>{" "}
                              </span>
                            }
                            className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                          />
                        </div>

                        {/* Product Detail Panel */}
                        <div
                          className="px-3 "
                          style={{
                            maxHeight: `calc(100% - 115px)`,
                            minHeight: `calc(100% - 115px)`,
                            height: `calc(100% - 115px)`,
                          }}
                        >
                          <div className="flex h-full w-[100%] gap-5">
                            <div className="w-[49%] h-full flex flex-col gap-5">
                              <div className="h-[226px] w-full rounded-[12px] bg-[var(--slide-panel-con-bg)] mt-[1rem] p-4">
                                <h2
                                  className="font-[var(--slide-panel-h1-fw)]
            text-[length:var(--slide-panel-h1-fs)]
            text-[var(--slide-panel-h1-fg)]"
                                >
                                  {productDetails?.item_name}
                                </h2>
                                <div className="flex gap-3 items-center">
                                  <SelectField
                                    handleSelected={(sel) => {
                                      setLoading(true);
                                      setCurrentBatch({
                                        ...currentBatch,
                                        item_batch_number: sel?.value,
                                      });
                                    }}
                                    defaultSelectClass="selectField h-[36px]] focus_outline__none"
                                    containerClass="w-[50%] mt-[1rem]"
                                    isDisabled={false}
                                    placeholder={"Select batch"}
                                    options={data?.map((batch) => ({
                                      label: batch?.item_batch_number,
                                      value: batch?.item_batch_number,
                                    }))}
                                    label={"Batch:"}
                                    id={"item_batch_number"}
                                    name="item_batch_number"
                                    isSearchable={true}
                                    errMsgContainerClass="ps-2"
                                    isRequired={false}
                                    labelWidth="3rem"
                                  />

                                  <div
                                    className={`w-fit px-2 py-1 rounded-[8px] font-[var(--status-badge-fw)] text-[length:var(--status-badge-fs)] ${
                                      productDetails?.stock_status ===
                                      "In Stock"
                                        ? "border border-[var(--status-badge-green-border)] bg-[var(--status-badge-green-bg)] text-[var(--status-badge-green-fg)]"
                                        : "border border-[var(--status-badge-red-border)] bg-[var(--status-badge-red-bg)] text-[var(--status-badge-red-fg)]"
                                    }`}
                                  >
                                    {productDetails?.stock_status}
                                  </div>
                                </div>
                                <div className="mt-[1rem] bg-[var(--slide-panel-special-bg)] rounded-[4px] h-[79px] p-2">
                                  <div className={`flex flex-col gap-2`}>
                                    <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                      Unit MRP
                                    </div>
                                    <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                      ₹{values?.unit_mrp || 0}
                                    </div>
                                    <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                      MRP ₹{values?.item_mrp_price} /{" "}
                                      {values?.units_per_pack} units
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  maxHeight: `calc(100% - 300px)`,
                                  minHeight: `338px`,
                                }}
                                className=" overflow-y-auto w-full rounded-[12px] bg-[var(--slide-panel-con-bg)] mt-[1rem] p-4"
                              >
                                <TabsComponent
                                  handleClickfn={(item) => {
                                    setCurrentTab(item);
                                  }}
                                  itemTabs={[
                                    "Basic Pricing",
                                    ...(values?.advanced_pricing?.length > 0
                                      ? ["Advanced Pricing"]
                                      : []),
                                  ]}
                                  setCurrentTab={setCurrentTab}
                                  currentTab={currentTab}
                                />
                                {currentTab === "Basic Pricing" && (
                                  <>
                                    <div className="flex gap-5 w-full mt-[1rem]">
                                      <InputField
                                        containerClass="w-[50%]"
                                        parentClass="flex flex-col gap-1"
                                        isDisabled={false}
                                        type="text"
                                        name="item_unit_price"
                                        placeholder="MRP"
                                        label="MRP (Incl. GST)"
                                        labelWidth="6.5rem"
                                        errMsgContainerClass="hidden"
                                      />
                                      <InputField
                                        containerClass="w-[50%]"
                                        parentClass="flex flex-col gap-1"
                                        isDisabled={true}
                                        type="text"
                                        name="final_cost_price_excl_gst"
                                        placeholder="price"
                                        label="Purchase Price (Excl. GST)"
                                        labelWidth="6.5rem"
                                        errMsgContainerClass="hidden"
                                      />
                                    </div>
                                    <div className="flex gap-5 w-full mt-[1.5rem] ">
                                      <InputField
                                        containerClass="w-[50%]"
                                        parentClass="flex flex-col gap-1"
                                        isDisabled={true}
                                        type="text"
                                        name="discount_percentage"
                                        placeholder="Dis %"
                                        label="Discount %"
                                        labelWidth="6.5rem"
                                        errMsgContainerClass="hidden"
                                      />
                                      <InputField
                                        containerClass="w-[50%]"
                                        parentClass="flex flex-col gap-1"
                                        isDisabled={true}
                                        type="text"
                                        name="gst"
                                        placeholder="Qty"
                                        label="GST %"
                                        labelWidth="6.5rem"
                                        errMsgContainerClass="hidden"
                                      />
                                    </div>
                                  </>
                                )}

                                {currentTab === "Advanced Pricing" && (
                                  <>
                                    {values?.advanced_pricing?.map(
                                      (price, index) => (
                                        <div
                                          key={index}
                                          className="flex gap-3 w-full mt-[1rem]"
                                        >
                                          <InputField
                                            containerClass="max-w-[23%]"
                                            parentClass="flex flex-col gap-1"
                                            isDisabled={true}
                                            type="text"
                                            name={`advanced_pricing[${index}].item_quantity`}
                                            placeholder="Qty"
                                            label="Qty"
                                            labelWidth="6.5rem"
                                            errMsgContainerClass="hidden"
                                          />
                                          <InputField
                                            containerClass="max-w-[23%]"
                                            parentClass="flex flex-col gap-1"
                                            isDisabled={true}
                                            type="text"
                                            name={`advanced_pricing[${index}].discount_percentage`}
                                            placeholder="Discount (%)"
                                            label="Discount (%)"
                                            labelWidth="6.5rem"
                                            errMsgContainerClass="hidden"
                                          />
                                          <InputField
                                            containerClass="max-w-[23%]"
                                            parentClass="flex flex-col gap-1"
                                            isDisabled={true}
                                            type="text"
                                            name={`advanced_pricing[${index}].discounted_amount`}
                                            placeholder="Discount (Amt)"
                                            label="Discount (Amt)"
                                            labelWidth="6.5rem"
                                            errMsgContainerClass="hidden"
                                          />
                                          <InputField
                                            containerClass="max-w-[23%]"
                                            parentClass="flex flex-col gap-1"
                                            isDisabled={true}
                                            type="text"
                                            name={`advanced_pricing[${index}].effective_price`}
                                            placeholder="Effective"
                                            label="Effective"
                                            labelWidth="6.5rem"
                                            errMsgContainerClass="hidden"
                                          />
                                        </div>
                                      )
                                    )}
                                  </>
                                )}
                                <div className="border-[var(--slide-panel-border)] border mt-[1rem]"></div>
                                <div
                                  className={`flex justify-between  mt-[1rem]`}
                                >
                                  <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                    Final Cost Price (Excl. GST)
                                  </div>
                                  <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                    {values?.final_cost_price_excl_gst}
                                  </div>
                                </div>
                                <div
                                  className={`flex justify-between  mt-[0.5rem]`}
                                >
                                  <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                    Final Cost (Incl. GST)
                                  </div>
                                  <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                    {values?.final_cost_price_incl_gst}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="w-[49%] flex flex-col gap-5 h-full">
                              <div className="h-[226px] w-full rounded-[12px] bg-[var(--slide-panel-con-bg)] mt-[1rem] p-4">
                                <h2
                                  className="font-[var(--slide-panel-h1-fw)]
            text-[length:var(--slide-panel-h1-fs)]
            text-[var(--slide-panel-h1-fg)]"
                                >
                                  Code Batch Details{" "}
                                </h2>

                                <div className="flex gap-5 w-full mt-[1rem]">
                                  <InputField
                                    containerClass="w-[50%]"
                                    parentClass="flex flex-col gap-1"
                                    isDisabled={true}
                                    type="date"
                                    name="item_exp_date"
                                    placeholder="xxxxxxxxxxxxxxx"
                                    label="Expiry Date"
                                    labelWidth="6.5rem"
                                    errMsgContainerClass="hidden"
                                  />
                                  <InputField
                                    containerClass="w-[50%]"
                                    parentClass="flex flex-col gap-1"
                                    isDisabled={true}
                                    type="text"
                                    name="item_hsn"
                                    placeholder="HSN"
                                    label="HSN Code"
                                    labelWidth="6.5rem"
                                    errMsgContainerClass="hidden"
                                  />
                                </div>
                                <div className="flex gap-5 w-full mt-[1.5rem]">
                                  <InputField
                                    containerClass="w-[50%]"
                                    parentClass="flex flex-col gap-1"
                                    isDisabled={true}
                                    type="text"
                                    name="units_per_pack"
                                    placeholder="Units"
                                    label="Units per Pack"
                                    labelWidth="6.5rem"
                                    errMsgContainerClass="hidden"
                                  />
                                  <InputField
                                    containerClass="w-[50%]"
                                    parentClass="flex flex-col gap-1"
                                    isDisabled={true}
                                    type="text"
                                    name="item_quantity"
                                    placeholder="Qty"
                                    label="Quantity in Stock"
                                    labelWidth="6.5rem"
                                    errMsgContainerClass="hidden"
                                  />
                                </div>
                              </div>
                              <div
                                style={{
                                  maxHeight: `calc(100% - 300px)`,
                                  minHeight: `284px`,
                                }}
                                className="  overflow-y-auto w-full rounded-[12px] bg-[var(--slide-panel-con-bg)] mt-[1rem] p-4"
                              >
                                <h2
                                  className="font-[var(--slide-panel-h1-fw)]
            text-[length:var(--slide-panel-h1-fs)]
            text-[var(--slide-panel-h1-fg)]"
                                >
                                  Margin & Profitability
                                </h2>

                                {currentTab === "Basic Pricing" && (
                                  <>
                                    <div
                                      className={`flex justify-between  mt-[2rem]`}
                                    >
                                      <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                        Our Margin (%)
                                      </div>
                                      <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                        ₹{values?.final_cost_price_excl_gst}
                                      </div>
                                    </div>
                                    <div
                                      className={`flex justify-between  mt-[1rem]`}
                                    >
                                      <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                        Margin %
                                      </div>
                                      <div className="text-[var(--success-color)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                        {values?.margin_percentage}%
                                      </div>
                                    </div>
                                    <div className="border-[var(--slide-panel-border)] border mt-[1rem]"></div>
                                    <h2
                                      className="font-[var(--slide-panel-h1-fw)]
            text-[length:var(--slide-panel-h1-fs)]
            text-[var(--slide-panel-h1-fg)] mt-[1rem]"
                                    >
                                      Breakdown
                                    </h2>
                                    <div
                                      className={`flex justify-between  mt-[1rem]`}
                                    >
                                      <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                        MRP
                                      </div>
                                      <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                        ₹{values?.item_mrp_price}
                                      </div>
                                    </div>
                                    <div
                                      className={`flex justify-between  mt-[1rem]`}
                                    >
                                      <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                        Cost Price
                                      </div>
                                      <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                        ₹{values?.final_cost_price_incl_gst}
                                      </div>
                                    </div>
                                    <div
                                      className={`flex justify-between  mt-[1rem]`}
                                    >
                                      <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                        Profit
                                      </div>
                                      <div className="text-[var(--success-color)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                        {values?.profit_margin}%
                                      </div>
                                    </div>
                                  </>
                                )}

                                {currentTab === "Advanced Pricing" && (
                                  <>
                                    {values?.advanced_pricing?.map(
                                      (price, index) => (
                                        <>
                                          <h2
                                            className="font-[var(--slide-panel-h1-fw)]
            text-[length:var(--slide-panel-h1-fs)]
            text-[var(--slide-panel-h1-fg)] mt-[1rem]"
                                          >
                                            Special Price {index + 1}
                                          </h2>
                                          <div
                                            className={`flex justify-between  mt-[1rem]`}
                                          >
                                            <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                              Special Price (Excl. GST)
                                            </div>
                                            <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                              ₹{price?.special_price_exc_tax}
                                            </div>
                                          </div>
                                          <div
                                            className={`flex justify-between  mt-[1rem]`}
                                          >
                                            <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                              Special Price (Incl. GST)
                                            </div>
                                            <div className="text-[var(--slide-panel-value)] text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap">
                                              ₹{price?.special_price_inc_tax}
                                            </div>
                                          </div>
                                          <div
                                            className={`flex justify-between  mt-[1rem]`}
                                          >
                                            <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                              Margin (₹)
                                            </div>
                                            <div
                                              className={`${
                                                price?.profit_margin > 0
                                                  ? "text-[var(--success-color)]"
                                                  : "text-[var(--error-color)]"
                                              } text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap`}
                                            >
                                              ₹{price?.profit_margin}
                                            </div>
                                          </div>
                                          <div
                                            className={`flex justify-between  mt-[1rem]`}
                                          >
                                            <div className="text-[var(--slide-panel-label)] text-[length:var(--slide-panel-label-fs)] font-[var(--slide-label-value-fw)]">
                                              Margin (%)
                                            </div>
                                            <div
                                              className={`${
                                                price?.margin_percentage > 0
                                                  ? "text-[var(--success-color)]"
                                                  : "text-[var(--error-color)]"
                                              } text-[length:var(--slide-panel-value-fs)] font-[var(--slide-panel-value-fw)] text-wrap`}
                                            >
                                              {price?.margin_percentage}%
                                            </div>
                                          </div>
                                          {index <
                                            values?.advanced_pricing?.length -
                                              1 && (
                                            <div className="border-[var(--slide-panel-border)] border mt-[1rem]"></div>
                                          )}
                                        </>
                                      )
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-between h-[50px]  items-center px-3">
                          <AddButton
                            prefixIcon={false}
                            onclkFn={() => {
                              setOpen(false);
                              // setProductDetails({ item_id: "" });
                            }}
                            text={
                              <span>
                                Cancel <span className="opacity-50">(C)</span>{" "}
                              </span>
                            }
                            className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                          />
                          <AddButton
                            prefixIcon={false}
                            text={
                              <span>
                                Save <span className="opacity-50">(S)</span>{" "}
                              </span>
                            }
                            className="
    flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-font-size)] 
    font-[var(--primary-button-font-weight)]
  "
                            type="submit"
                          />
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
                <LoadingOverlay />
              </Dialog.Panel>
            </Transition.Child>
          </div>
          <LoadingOverlay isLoading={loading} />
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const heading = [
  { label: "Store Code", value: "store_code" },
  { label: "Store Address", value: "store_address" },
  { label: "Store Type", value: "store_type" },
  { label: "Expiry Status", value: "expiry_status" },
  { label: "Stock Status", value: "stock_status" },
  { label: "MRP Range", value: "max_mrp_range" },
  { label: "Sale Rate Range", value: "sale_rate_range" },
  { label: "Available Qty", value: "available_qty" },
  { label: "No. of Batches", value: "batch_count" },
  { label: "Action", value: "action" },
];
